module.exports = __webpack_public_path__ + "static/media/IET.a1eac782.jpg";